import { PolicyViolationOutcomeMap } from '@agilelab/plugin-wb-governance-common';
import { CustomViewRegister } from '../CustomView/registry';
import { FlagBoxContent } from '../FlagBox';
import { CustomViewGridElement } from './utility';

CustomViewRegister.register({
  id: 'violations-status-summary',
  function: function PolicyFlag(props: Record<string, any>) {
    const value: PolicyViolationOutcomeMap = new Map(props.value);
    if (value.size === 0) {
      return <>-</>;
    }

    return (
      <CustomViewGridElement colSpan={props.colSpan}>
        <span style={{ display: 'flex' }}>
          <FlagBoxContent policyViolationsOutcomeMap={value} />
        </span>
      </CustomViewGridElement>
    );
  },
});
